var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auditStatistics)?_c('number-card',{attrs:{"success":"","bold":"","amount":_vm.performedAudits,"title":_vm.$it('dashboard.card.audits-reviewed-this-month.title', 'Audits reviewed this month')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }